import { Subject } from 'rxjs';
const queues = new Set();
export function createQueue(id) {
    id && queues.add(id);
}
export const events$ = new Subject();
window.f5.onMirrorUpdate(e => events$.next(e));
